// extracted by mini-css-extract-plugin
export default {"ConsultationTypes":"ConsultationTypes_ConsultationTypes__CYqwm","TypeContainer":"ConsultationTypes_TypeContainer__k7N8u"};